/**
 * Colors
 *
 * Find your color name here
 * http://chir.ag/projects/name-that-color
 */

var alabaster = '#fafafa';
var alto = '#e0e0e0';
var azure = '#375ea9';
var bayOfMany = '#2d2d87';
var black = '#000000';
var bluemine = '#1f5d81';
var blueViolet = '#596cb3';
var bostonBlue = '#3d7bba';
var bush = '#0f3916';
var camouflageGreen = '#7a8975';
var cloudBurst = '#253553';
var conifer = '#b1d23e';
var cornflower = '#93d4e5';
var dodgerBlue = '#4892f9';
var doveGray = '#707070';
var eucalyptus = '#1c9853';
var fiord = '#395666';
var frenchRose = '#f14668';
var grayNurse = '#f2f3f2';
var mineShaft = '#292929';
var mirage = '#161F28';
var mystic = '#dce5ea';
var nileBlue = '#172B4E';
var norway = '#a3b69c';
var parsley = '#185126';
var plantation = '#284837';
var pomegranate = '#f12222';
var prussianBlue = '#00385B';
var regentGray = '#7a8fa1';
var salem = '#08753e';
var shakespeare = '#4ca8d6';
var silver = '#C3C3C3';
var silverChalice = '#acacac';
var skeptic = '#c9e7e3';
var stTropaz = '#2A659F';
var supernova = '#ffcc0a';
var tasman = '#d3ddd0';
var teal = '#89d3de';
var tango = '#f36e21';
var tundora = '#404040';
var white = '#ffffff';
var whiteSmoke = '#f5f5f5';
var wildSand = '#f5f5f5';

export { alabaster, alto, azure, bayOfMany, black, blueViolet, bluemine, bostonBlue, bush, camouflageGreen, cloudBurst, conifer, cornflower, dodgerBlue, doveGray, eucalyptus, fiord, frenchRose, grayNurse, mineShaft, mirage, mystic, nileBlue, norway, parsley, plantation, pomegranate, prussianBlue, regentGray, salem, shakespeare, silver, silverChalice, skeptic, stTropaz, supernova, tango, tasman, teal, tundora, white, whiteSmoke, wildSand };
